import React from 'react';
import { Link } from 'react-router-dom';

function LinkCard({ title, actionText = title, link, onClick }) {

  const renderLinkToRoute = () => {
    return <Link to={link}>{actionText}</Link>;
  }

  const renderLinkToAction = () => {
    return <Link to={link} onClick={onClick}>{actionText}</Link>;
  }

  const renderLink = () => {
    return onClick ? renderLinkToAction() : renderLinkToRoute();
  };

  return (
    <div className="col l3 m6 s12">
      <div className="card horizontal">
        <div className="card-stacked">
          <div className="card-content">
            <p>{title}</p>
          </div>
          <div className="card-action">
            {renderLink()}
          </div>
        </div>
      </div>
    </div>
  )
}

export default LinkCard;
